import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  Link,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import {
  Menu as MenuIcon,
  ArrowBack,
  ArrowDropDown,
  ArrowDropUp,
} from '@material-ui/icons';
import PatientAgendaRequest from './PatientAgendaRequest';
import { AvatarMenu } from './RightMenu';
import DoctariModal from '../Modal';
import { userActions } from '../../redux/user/actions';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import {
  PROFILE,
  HOMEPAGE,
  SCHEDULE_REQUESTS,
  APPOINTMENTS,
  HISTORIC_APPOINTMENTS,
  VIDEO_CALL_TEST,
  CHECKOUT,
  SUBSCRIPTIONS,
} from '../../utils/urls';
import { isProfessional } from '../../utils/helpers';
import doctariLogo from '../../assets/doctari_logo.svg';
import teledoktorLogo from '../../assets/binomio/teledoktor_logo_white.png';
import {
  desktopTabs,
  mobileOptions,
  mobileOptionsMenuAssistant,
} from './constants';
import { MenuAssistant } from './DropMenuAssistant';

const useStyles = makeStyles((theme) => ({
  header: {
    height: '5rem',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    height: '3rem',
    '@media (max-width: 900px)': {
      height: '2.5rem',
    },
    '@media (max-width: 412px)': {
      // height: '2.5rem',
      width: '100%',
    },
  },
  img_binomio: {
    height: '4rem',
    '@media (max-width: 900px)': {
      height: '3.5rem',
    },
    '@media (max-width: 412px)': {
      height: '3rem',
    },
  },
  headerLogin: {
    backgroundColor: theme.palette.primary.main,
    '@media (max-width: 900px)': {
      paddingLeft: 0,
    },
  },
  menuButton: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    marginRight: '2rem',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  drawerContainer: {
    padding: '10px 20px',
    paddingRight: '45px',
  },
  menuContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  //Avatar:
  avatarContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    cursor: 'pointer',
  },
  avatar: {
    border: 'solid 2px #b8f3f3',
    marginRight: '1rem',
  },
}));

function Header({
  session,
  logoutUser,
  style,
  appointmentsData,
  getScheduleRequests,
  updateScheduleRequests,
  acceptScheduleRequest,
}) {
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const isCheckout = location.pathname === CHECKOUT;
  const isMainPage = location.pathname == APPOINTMENTS;
  const isProfile = location.pathname == PROFILE;
  const hideHeaderNav = isCheckout && session && session.email;

  const { headerLogin, menuButton, toolbar, drawerContainer } = classes;
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
    open: false,
    modalOpen: false,
  });
  const { mobileView, drawerOpen, modalOpen } = state;
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 900
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener('resize', () => setResponsiveness());

    return () => {
      window.removeEventListener('resize', () => setResponsiveness());
    };
  }, []);

  const DrawerChoices = ({ choices }) => {
    return choices.map(({ label, href }) => {
      return (
        <Link
          {...{
            component: RouterLink,
            to: href,
            color: 'inherit',
            style: { textDecoration: 'none' },
            key: label,
          }}
          onClick={() => {
            if (label === 'Solicitudes de agenda') {
              if (isProfessional(session.userType)) {
                history.push(SCHEDULE_REQUESTS);
              } else {
                setState({ ...state, drawerOpen: null, modalOpen: true });
              }
            }
          }}
        >
          <MenuItem>{label}</MenuItem>
        </Link>
      );
    });
  };

  const GetHeaderTabs = ({ choices }) => {
    return choices.map(({ label, href }) => {
      return (
        <Button
          {...{
            key: label,
            color: 'inherit',
            className: menuButton,
          }}
          onClick={() => {
            if (label.toLowerCase() === 'solicitudes de agenda') {
              if (isProfessional(session.userType)) {
                history.push(SCHEDULE_REQUESTS);
              } else {
                setState({ ...state, modalOpen: true });
              }
            } else if (label.toLowerCase() === 'histórico de consulta') {
              history.push(HISTORIC_APPOINTMENTS);
            } else if (label.toLowerCase() === 'mis consultas') {
              history.push(APPOINTMENTS);
            } else if (label.toLowerCase() === 'probar video') {
              history.push(VIDEO_CALL_TEST);
            } else {
              history.push(href);
            }
          }}
        >
          {label}
        </Button>
      );
    });
  };

  const GetHeaderAssistantOperator = ({ isProfile }) => {
    return (
      <>
        {!isProfile && (
          <>
            {/*   <Button
              {...{
                key: 'solicitudes de agenda',
                color: 'inherit',
                className: menuButton,
              }}
              onClick={() => {
                history.push(SCHEDULE_REQUESTS);
              }}
            >
              SOLICITUDES DE AGENDA
            </Button> */}
            <MenuAssistant
              classes={classes}
              openModal={() => setState({ ...state, modalOpen: true })}
              logout={logoutUser}
              // goProfile={() => history.push(PROFILE)}
              // userName={session.name}
              // profilePic={session.profilePic}
            />
          </>
        )}
      </>
    );
  };

  const HeaderDesktop = () => {
    if (!session || !session.email) {
      return (
        <div className={classes.header}>
          <MainLogo />
        </div>
      );
    }
    return (
      <Toolbar className={toolbar}>
        {!isMainPage && !hideHeaderNav && (
          <IconButton
            style={{ color: 'white' }}
            onClick={() => {
              history.push(HOMEPAGE);
            }}
          >
            <ArrowBack />
            <span style={{ marginLeft: '0.5rem' }}>Volver </span>
          </IconButton>
        )}
        {(isMainPage || hideHeaderNav) && <MainLogo />}
        <div className={classes.menuContainer}>
          {!hideHeaderNav &&
            (session.userType === 'assistant' ||
            session.userType === 'operator' ? (
              <GetHeaderAssistantOperator isProfile={isProfile} />
            ) : (
              <GetHeaderTabs
                choices={isProfile ? [] : desktopTabs(session.userType)}
              />
            ))}
          <AvatarMenu
            classes={classes}
            openModal={() => setState({ ...state, modalOpen: true })}
            logout={logoutUser}
            goProfile={() =>
              history.push({ pathname: PROFILE, state: { profileType: '' } })
            }
            userName={session.name}
            profilePic={session.profilePic}
          />
        </div>
      </Toolbar>
    );
  };

  const HeaderMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    if (!session || !session.email) {
      return (
        <Toolbar style={{ justifyContent: 'center' }}>
          <MainLogo />
        </Toolbar>
      );
    }
    if (hideHeaderNav) {
      return (
        <Toolbar className={toolbar}>
          <MainLogo />
          <AvatarMenu
            classes={classes}
            openModal={() => setState({ ...state, modalOpen: true })}
            logout={logoutUser}
            goProfile={() =>
              history.push({ pathname: PROFILE, state: { profileType: '' } })
            }
            userName={session.name}
            profilePic={session.profilePic}
          />
        </Toolbar>
      );
    }
    return (
      <Toolbar style={{ justifyContent: 'space-between' }}>
        <Grid container alignItems='center'>
          <Grid item xs={10}>
            <MainLogo />
          </Grid>
          <Grid container item xs={2} justifyContent='flex-end'>
            <IconButton
              {...{
                edge: 'end',
                color: 'inherit',
                'aria-label': 'menu',
                'aria-haspopup': 'true',
                onClick: handleDrawerOpen,
              }}
            >
              <MenuIcon style={{ fontSize: '2rem' }} />
            </IconButton>
          </Grid>
          {session.userType == 'assistant' || session.userType == 'operator' ? (
            <Drawer
              {...{
                anchor: 'right',
                open: drawerOpen,
                onClose: handleDrawerClose,
              }}
            >
              <List style={{ width: '12rem' }}>
                <ListItem button onClick={() => setOpenMenu(!openMenu)}>
                  <ListItemText primary='Menú' />

                  {openMenu ? <ArrowDropUp /> : <ArrowDropDown />}
                </ListItem>
                <Collapse in={openMenu} timeout='auto' unmountOnExit>
                  <List component='div' disablePadding>
                    {mobileOptionsMenuAssistant.map(({ label, href }) => {
                      if (label == 'Lista de usuario') {
                        return (
                          <ListItem
                            button
                            onClick={() =>
                              history.push({
                                pathname: href,
                                state: {
                                  list: 'users',
                                },
                              })
                            }
                            disablePadding
                          >
                            <ListItemText primary={label} />
                          </ListItem>
                        );
                      } else if (label == 'Lista de doctores') {
                        return (
                          <ListItem
                            button
                            onClick={() =>
                              history.push({
                                pathname: href,
                                state: {
                                  list: 'doctors',
                                },
                              })
                            }
                            disablePadding
                          >
                            <ListItemText primary={label} />
                          </ListItem>
                        );
                      } else if (label == 'Perfil Doctor') {
                        return (
                          <ListItem
                            button
                            onClick={() =>
                              history.push({
                                pathname: href,
                                state: {
                                  profileType: 'profileDoctor',
                                },
                              })
                            }
                            disablePadding
                          >
                            <ListItemText primary={label} />
                          </ListItem>
                        );
                      } else {
                        return (
                          <ListItem
                            button
                            onClick={() =>
                              history.push({
                                pathname: href,
                              })
                            }
                            disablePadding
                          >
                            <ListItemText primary={label} />
                          </ListItem>
                        );
                      }
                    })}
                  </List>
                </Collapse>

                <div style={{ width: '100%', border: 'solid 1px #8080803b' }} />
                <MenuItem
                  onClick={() =>
                    history.push({
                      pathname: PROFILE,
                      state: { profileType: '' },
                    })
                  }
                >
                  Mi Perfil
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    history.push(SUBSCRIPTIONS);
                  }}
                >
                  Suscripción
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  Salir
                </MenuItem>
              </List>
            </Drawer>
          ) : (
            <Drawer
              {...{
                anchor: 'right',
                open: drawerOpen,
                onClose: handleDrawerClose,
              }}
            >
              <div className={drawerContainer}>
                <DrawerChoices choices={mobileOptions} />
                <div style={{ width: '100%', border: 'solid 1px #8080803b' }} />
                <MenuItem
                  onClick={() =>
                    history.push({
                      pathname: PROFILE,
                      state: { profileType: '' },
                    })
                  }
                >
                  Mi Perfil
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    history.push(SUBSCRIPTIONS);
                  }}
                >
                  Suscripción
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  Salir
                </MenuItem>
              </div>
            </Drawer>
          )}
        </Grid>
      </Toolbar>
    );
  };

  const MainLogo = () => {
    let logo = doctariLogo;
    let style = classes.img;
    if (process.env.REACT_APP_NAME === 'binomio') {
      logo = teledoktorLogo;
      style = classes.img_binomio;
    }
    return (
      <img
        alt='logo'
        src={logo}
        className={style}
        style={{ cursor: session.email ? 'pointer' : 'initial' }}
        onClick={() => session.email && history.push(HOMEPAGE)}
      />
    );
  };

  if (isProfile) {
    return (
      <header>
        <AppBar
          className={headerLogin}
          style={{ position: 'relative', boxShadow: '0 0 0 0' }}
        >
          {mobileView ? <HeaderMobile /> : <HeaderDesktop />}
        </AppBar>
      </header>
    );
  }
  return (
    <header>
      <DoctariModal
        open={modalOpen}
        setOpen={(val) => setState({ ...state, modalOpen: val })}
        title={'Solicitudes pendientes'}
        hideCross
      >
        <PatientAgendaRequest
          closeModal={() => setState({ ...state, modalOpen: false })}
          scheduleRequests={appointmentsData.scheduleRequests}
          appointmentsData={appointmentsData}
          loading={appointmentsData.loading}
          getScheduleRequests={() =>
            getScheduleRequests(
              `?${session.userType}=${session.id}&status__in=waiting_doctor, waiting_patient`,
              session.accessToken
            )
          }
          updateScheduleRequests={updateScheduleRequests}
          acceptScheduleRequest={acceptScheduleRequest}
          userId={session.id}
          token={session.accessToken}
        />
      </DoctariModal>
      <AppBar className={headerLogin} style={{ ...style, paddingRight: '0px' }}>
        {mobileView ? <HeaderMobile /> : <HeaderDesktop />}
      </AppBar>
    </header>
  );
}

const mapStateToProps = ({ session, appointments }) => {
  return {
    session,
    appointmentsData: appointments,
  };
};

const mapDispatchToProps = (dispatch) => ({
  logoutUser: () => dispatch(userActions.logoutUser()),
  getScheduleRequests: (queryId, token) =>
    dispatch({
      type: appointmentActionsTypes.GET_SCHEDULE_REQUESTS,
      payload: { queryId, token },
    }),
  updateScheduleRequests: (queryId, id, body, token) =>
    dispatch({
      type: appointmentActionsTypes.UPDATE_SCHEDULE_REQUESTS,
      payload: { queryId, id, body, token },
    }),
  acceptScheduleRequest: (body, token) =>
    dispatch({
      type: appointmentActionsTypes.ACCEPT_SCHEDULE_REQUESTS,
      payload: { body, token },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
